import { render } from "./ManualDialog.vue?vue&type=template&id=3275abd5&scoped=true"
import script from "./ManualDialog.vue?vue&type=script&lang=js"
export * from "./ManualDialog.vue?vue&type=script&lang=js"

import "./ManualDialog.vue?vue&type=style&index=0&id=3275abd5&lang=scss&scoped=true"

import exportComponent from "/Users/ilss0902/PorjectCenter/Cloudmobile/雲端POS_V2/code/pos_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3275abd5"]])

export default __exports__